module.exports = __webpack_public_path__ + "img/bambelo_screen.086b233.png";